export default __webpack_public_path__ + "static/media/shannon-ahn.com.67769264.jpg";